import type { NskResponse } from "~/models/Api";
import type { DealConstructionScheduleEdit } from "~/models/DealConstructionSchedule";
import { generatePath } from "~/utils/generatePath";
import { putRequest } from "../api_handler";

export const update = async (
	dealId: number,
	schedules: DealConstructionScheduleEdit[]
): Promise<NskResponse> =>
	putRequest(
		generatePath("/deals/:deal_id/deal_construction_schedules", {
			deal_id: dealId
		}),
		{ dealConstructionSchedules: schedules }
	);
